import {ChangeDetectionStrategy, Component, computed, input, model} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {Accordion, AccordionContent, AccordionHeader, AccordionPanel} from 'primeng/accordion';
import {Dialog} from 'primeng/dialog';
import {RfpCriterionHeaderComponent} from './parts/rfp-criterion-header/rfp-criterion-header.component';
import {RfpHighlightListComponent} from './parts/rfp-highlight-list/rfp-highlight-list.component';
import {RfpSubCriteriaListComponent} from './parts/rfp-sub-criteria-list/rfp-sub-criteria-list.component';
import {RfpTotalSummaryComponent} from './parts/rfp-total-summary/rfp-total-summary.component';
import {RfpIndividualResults} from './rfp-individual-results.types';

@Component({
  selector: 'app-rfp-individual-results-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoPipe,
    Dialog,
    Accordion,
    AccordionPanel,
    AccordionHeader,
    AccordionContent,
    RfpTotalSummaryComponent,
    RfpHighlightListComponent,
    RfpCriterionHeaderComponent,
    RfpSubCriteriaListComponent,
  ],
  templateUrl: './rfp-individual-results-modal.component.html',
})
export class RfpIndividualResultsModalComponent {
  readonly visible = model(false);
  readonly toolName = input<string | undefined>();
  readonly results = input<RfpIndividualResults | null>(null);

  protected readonly titleParams = computed(() => ({tool: this.toolName() ?? ''}));
}
